"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AppelAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section ref={ref} className="relative min-h-screen flex items-center justify-center px-4 py-20">
      <div className={`
          glass-effect
          max-w-3xl w-full px-8 py-12 md:px-12 md:py-16
          text-center
          transition-all duration-[var(--duration-slow)] ease-[var(--ease-out-back)]
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
        `}>
        <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-6 leading-tight">
          Entamez une Conversation Stratégique
        </h2>
        <p className="text-lg md:text-xl text-muted-foreground mb-10 leading-relaxed">
          Transformez la complexité en clarté. Engagez-vous avec NorthStar Advisory pour créer de la valeur durable grâce à l'excellence stratégique.
        </p>
        <Link to="#contact">
          <Button size="lg" className="
              btn-primary
              text-base md:text-lg
              px-10 py-6
              shadow-medium
              hover:scale-105
              active:scale-100
              transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]
            ">On echange ?</Button>
        </Link>
      </div>
    </section>;
}